export function updateObjectInArray(arr, obj, idKey = 'id') {
  const index = arr.findIndex(({ [idKey]: id }) => id === obj[idKey]);

  if (index === -1) return arr;

  return [
    ...arr.slice(0, index),
    { ...arr[index], ...obj },
    ...arr.slice(index + 1),
  ];
}

export function removeObjectFromArrayByKey(arr, key, keyName = 'id') {
  return arr.filter(({ [keyName]: objKey }) => objKey !== key);
}
